const GET_USER_ORG = "GET_USER_ORG";
const TOGGLE_ORG_LOADING = "TOGGLE_ORG_LOADING";

const GET_ORG_DIR = "GET_ORG_DIR";
const TOGGLE_ORG_DIR_LOADING = "TOGGLE_ORG_DIR_LOADING";
const SET_ORG_DIR_ERROR = "SET_ORG_DIR_ERROR";

const GET_ORG_CODE_LIB = "GET_ORG_CODE_LIB";
const SET_ORG_CODE = "SET_ORG_CODE";
const DELETE_ORG_CODE = "DELETE_ORG_CODE";

const UPDATE_ORGANIZATION_START = "UPDATE_ORGANIZATION_START";
const UPDATE_ORGANIZATION_SUCCESS = "UPDATE_ORGANIZATION_SUCCESS";
const UPDATE_ORGANIZATION_FAIL = "UPDATE_ORGANIZATION_FAIL";

const UPDATE_ORGANIZATION_CHBA_WORKBOOK_TEMPLATE_START = "UPDATE_ORGANIZATION_CHBA_WORKBOOK_TEMPLATE_START";
const UPDATE_ORGANIZATION_CHBA_WORKBOOK_TEMPLATE_SUCCESS = "UPDATE_ORGANIZATION_CHBA_WORKBOOK_TEMPLATE_SUCCESS";
const UPDATE_ORGANIZATION_CHBA_WORKBOOK_TEMPLATE_FAIL = "UPDATE_ORGANIZATION_CHBA_WORKBOOK_TEMPLATE_FAIL";

export default {
    GET_USER_ORG,
    TOGGLE_ORG_LOADING,
    GET_ORG_DIR,
    TOGGLE_ORG_DIR_LOADING,
    SET_ORG_DIR_ERROR,
    GET_ORG_CODE_LIB,
    SET_ORG_CODE,
    DELETE_ORG_CODE,
    UPDATE_ORGANIZATION_START,
    UPDATE_ORGANIZATION_SUCCESS,
    UPDATE_ORGANIZATION_FAIL,
    UPDATE_ORGANIZATION_CHBA_WORKBOOK_TEMPLATE_START,
    UPDATE_ORGANIZATION_CHBA_WORKBOOK_TEMPLATE_SUCCESS,
    UPDATE_ORGANIZATION_CHBA_WORKBOOK_TEMPLATE_FAIL,
};
